import { IReportService } from "../../service/report/ReportService";

export default class GetReport3DataInteractor {
  private reportService: IReportService;

  constructor(reportService) {
    this.reportService = reportService;
  }

  async execute(
    reportingPeriodId: number,
    periodFrom: Date,
    periodTo: Date,
    min: number,
    max: number,
    submitReason?: string
  ) {
    return this.reportService.getReport3Data(
      reportingPeriodId,
      periodFrom,
      periodTo,
      min,
      max,
      submitReason
    );
  }
}
